import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-verti-scroll',
    templateUrl: './verti-scroll.component.html',
    styleUrls: ['./verti-scroll.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VertiScrollComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
